import { useOutletContext } from '@remix-run/react';
import { type DehydratedState } from '@tanstack/react-query';

import { type DeviceType, type Repub, type StateCode } from '@cx-modules/types';

import { OffersList } from '~/modules/OffersList';

import OffersPageTemplate from './template';

export { loader } from './loader';
export { meta } from './meta';

export type OffersPageProps = {
	apiKey: string;
	countryCode: string;
	deviceType: DeviceType;
	evergreenHtml: string;
	offersListResponse: {
		dehydratedState: DehydratedState;
	};
	path: string;
	repub: Repub;
	subdivisionCode: StateCode;
};

export default function OffersPage() {
	const {
		apiKey,
		countryCode,
		deviceType,
		evergreenHtml,
		offersListResponse,
		path,
		repub,
		subdivisionCode,
	}: OffersPageProps = useOutletContext();

	const renderOffersList = (
		<OffersList
			apiKey={apiKey}
			countryCode={countryCode}
			dehydratedState={offersListResponse.dehydratedState}
			deviceType={deviceType}
			path={path}
			repub={repub}
			subdivisionCode={subdivisionCode}
		/>
	);

	return (
		<div className="ogm-offers-page-wrapper">
			<aside className="takeover"></aside>
			<div className="ogm-offers-page-content">
				<OffersPageTemplate
					evergreenHtml={evergreenHtml}
					offersList={renderOffersList}
				/>
			</div>
			<aside className="takeover"></aside>
		</div>
	);
}
